import Image from 'next/image';
import React, { useRef } from 'react';
import Slider, { Settings as SliderSettings } from 'react-slick';

import Icon from '@/components/switchback/Icon/Icon';
import { ICONS } from '@/components/switchback/Icon/Icon.constants';

import css from './NewsSlider.module.css';

interface INewsSliderItem {
  title: string;
  description: string;
  descriptionBullets?: string[];
  img: string;
}

interface INewsSliderSettings extends SliderSettings {
  hasNextArrow?: boolean;
}

interface INewsSliderProps {
  items: INewsSliderItem[];
  settings?: Partial<INewsSliderSettings>;
}

const NewsSlider: React.FC<INewsSliderProps> = ({
  items,
  settings = {
    dots: true,
    arrows: false,
    autoplay: false,
    autoplaySpeed: 7000,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    hasNextArrow: true,
  },
}) => {
  const sliderRef: React.RefObject<Slider> = useRef(null);

  if (settings.hasNextArrow) {
    settings.appendDots = dots => {
      return (
        <div>
          <ul className="slick-dots">{dots}</ul>
          <button
            onClick={() => {
              sliderRef?.current?.slickNext();
            }}>
            <Icon name={ICONS.ARROW_RIGHT} className={css.rightArrow} />
          </button>
        </div>
      );
    };
  }

  return (
    <Slider className={css.sliderElement} ref={sliderRef} {...settings}>
      {items.map((item, index) => (
        <div className={css.sliderItemWrapper} key={index}>
          <div className={css.sliderItemWrapperInner}>
            <div className={css.sliderItemLeft}>
              <h3 className="h3">{item.title}</h3>
              <div className="mt-5">{item.description}</div>
              <ul>
                {item.descriptionBullets?.length &&
                  item.descriptionBullets.map((bullet, bIndex) => <li key={bIndex}>{bullet}</li>)}
              </ul>
            </div>
            <div className={css.sliderItemRight}>
              <div className={css.imageWrapper}>
                <Image
                  alt={item.title}
                  src={item.img}
                  role="presentation"
                  layout="intrinsic"
                  objectPosition="top"
                  width={448}
                  height={400}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default NewsSlider;
